define(['jquery', 'forms'], function ($, Forms) {
	var Quotation = function () {
		var self = this;
		self.forms = new Forms();
		self.$ervBody = $('#erv-body');
		self.$form = $('form[data-js-mainform]');

		self.deleteCompany = function ($company) {
			var deletedIndex = $company.data('id');
			$company.remove();
			self.refreshCompanies(deletedIndex);
			return deletedIndex;
		};
		
		self.refreshCompanies = function (deletedIndex) {
			var $allAdded = self.$companyList.find('.company.added');

			var $allNext = $allAdded.filter(function () {
				return ($(this).data('id') > deletedIndex); 
			});

			$allNext.each(function () {
				var $company = $(this);
				var index = $company.data('id'),
					newIndex = (index - 1);

				$company.find('.index').text(newIndex + 1);
				$company.data('id', newIndex);

				$company.find('input[type=text], input[data-inputtype="text"]').each(function () {
					var $input = $(this);
					$input.attr('name', $input.attr('name').replace(index, newIndex));
					$input.attr('id', $input.attr('id').replace(index, newIndex));
				});

				$company.find('label').each(function () {
					var $label = $(this);
					$label.attr('for', $label.attr('for').replace(index, newIndex));
				});
			});
		};
		
		self.addCompany = function () {
			var currentIndex = self.$companyList.find('.company').length,
				html = self.$companyTemplate.html().replace(/{{index}}/g, currentIndex);

			var $html = $(html);
			$html.find('.index').text(currentIndex + 1);

			$html.insertBefore($(self.$companyList.find('li').last()));

			var $inputs = $html.find('input[data-val="true"]');
			$inputs.each(function () {
				$(this).rules('add',
				{
					required: true
				});

				$(this).on('blur', function () {
					$(this).valid();
				});
			});
		};
		
		var showEmployeesFields = function ($childrenContainers, settings)
		{
			if (settings === "1") {
				$($childrenContainers[0]).removeClass('hide');
				$($childrenContainers[1]).addClass('hide');
				$($childrenContainers[1]).find('input[data-val="true"]').removeClass('input-validation-error');
				$($childrenContainers[1]).find('input[data-val="true"]').each(function() {
					var $input = $(this);
					$input.rules('remove');
				});
			}

			if (settings === "2") {
				$($childrenContainers[0]).removeClass('hide');
				$($childrenContainers[1]).removeClass('hide');

				var $inputs = $childrenContainers.find('input[data-val="true"]');
				$inputs.each(function () {
					$(this).rules('add',
					{
						required: true,
						messages: {
							required: $(this).data('val-requiredif')
						}
					});

					if ($(this).attr('id').indexOf('SocialSecurityNumber') > 0) {
						$(this).rules('add',
						{
							regex: $(this).data('val-regex-pattern'),
							messages: {
								regex: $(this).data('val-regex')
							}
						});
					}

					$(this).on('blur', function () {
						$(this).valid();
					});
				});
			}

			$childrenContainers.each(function () {
				var $container = $(this);

				if ($container.hasClass('hide')) {
					$container.find('input[data-val="true"]').removeClass('input-validation-error');
				} else {
					$container.find('input[data-val="true"]').removeClass('input-validation-valid');
				}
			});
		}

		self.setUpAmountOfEmployeesToggler = function () {
			var $this = self.$form.find('#Input_NrOfEmployees[data-js=toggle]'),
				$childrenContainers = $this.parents('.row-container').find('[data-toggle="children"]');

			if ($this.val() === "1" || $this.val() === "2") {
				showEmployeesFields($childrenContainers, $this.val());
			}

			$this.change(function () {
				if ($(this).val() === "1" || $(this).val() === "2") {
					showEmployeesFields($childrenContainers, $(this).val());
				} else {
					$childrenContainers.toggleClass('hide', true);

					$childrenContainers.each(function() {
						var $container = $(this);

						if ($container.hasClass('hide')) {
							$container.find('input[data-val="true"]').removeClass('input-validation-error');
						} else {
							$container.find('input[data-val="true"]').removeClass('input-validation-valid');
						}
					});
				}
			});
		}

		self.setupEventHandling = function() {
			self.$companyTemplate = self.$form.find("#company-template");
			self.$companyList = self.$form.find('#added-companies');

			self.$form.find('#add-company').on('click', function (e) {
				e.preventDefault();
				self.addCompany();
			});

			self.$companyList.on('click', '.company.added .remove-company', function (e) {
				e.preventDefault();
				self.deleteCompany($(this).parents('.company.added'));
			});

			self.forms.setupRadioTogglers(self.$form.find('*[data-js=toggle]'), '.row-container');

			self.setUpAmountOfEmployeesToggler();

			self.$form.find('#anothercompany-radiolist input').on('change', function () {
				var $input = $(this);
				if ($input.attr('id') === "Input_AnyOtherCompany_Yes") {
					self.addCompany();
				} else {
					self.$companyList.find('.company.added').remove();
				}
			});

			$('label[for="Input_HasPreviousInsurance_Yes"').on('click',
				function () {
					$('#Input_HasPreviousInsurance').prop('checked', true);
				});

			var $button = self.$ervBody.find('#send-quotation');
			$button.on('click', function (e) {
					if (!$button.parents('form').valid()) {
						e.preventDefault();
						e.stopPropagation();
					}
			});
		};
	};

	Quotation.prototype.init = function () {
		var self = this;

		self.setupEventHandling();
	}

	return Quotation;
});